/* eslint-disable global-require */
module.exports = ['artprice.landingpages.services.row6.testimonial.m1', 'artprice.landingpages.services.row6.testimonial.m2', 'artprice.landingpages.services.row6.testimonial.m3'];
